import React from 'react'
import logo from '../../Icons/softwaredevelopment.jpeg';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import Padding from '../Padding';
import NavBar from '../NavBar';
import SEO from '../../components/SEO'
import Sales from '../Sales';

class IOT extends React.Component {
    render() {
      return (

      <div id='IOT' style={{backgroundColor: '#0f0f14'}}>

        <NavBar/>
        <Padding/>
        <Padding/>
        <div className="container-text" style={{padding:"30px"}}>
            <h2>Internet of Things (IoT)</h2>
            <div> 




<div className="generic-column" style={{ width: '100%' }}>
    <h3>IoT & Edge Computing</h3>
    <p>
        We design and implement bespoke hardware and sensor networks that leverage 
        <strong> Edge Computing</strong> to process data locally. This architecture 
        reduces latency, minimises bandwidth costs, and ensures system reliability 
        by enabling autonomous decision-making before data is securely synchronised 
         with the cloud.
    </p>

    <p>
        We have extensive expertise in developing and deploying the following IoT technologies:
    </p>

    <div className="usp-list">
        <div className="usp-item">
            <strong>ESP32 & ESP-IDF</strong>
            <span>
                For high-performance, low-power sensor nodes, we utilise the 
                native Espressif IoT Development Framework (ESP-IDF). This allows 
                for professional-grade C/C++ firmware development, providing 
                granular control over memory, power management, and wireless stacks.
            </span>
        </div>

        <div className="usp-item">
            <strong>Raspberry Pi</strong>
            <span>
                Widely utilised as an industrial edge gateway, this platform allows for 
                sophisticated local data processing and bridging the gap 
                between shop-floor hardware and enterprise-level software suites.
            </span>
        </div>

        <div className="usp-item">
            <strong>BeagleBone</strong>
            <span>
                Chosen for applications requiring high-speed I/O and industrial-grade 
                reliability, we utilise these Linux-based systems for complex 
                real-time processing and advanced embedded control tasks.
            </span>
        </div>

        <div className="usp-item">
            <strong>MQTT & WebSockets</strong>
            <span>
                Effective IoT requires robust communication. We implement these 
                lightweight messaging protocols to ensure secure, real-time data 
                transfer between distributed devices and central monitoring platforms.
            </span>
        </div>

        <div className="usp-item">
            <strong>Wireless & BLE</strong>
            <span>
                We specialise in low-energy wireless integration, utilising Bluetooth 
                Low Energy (BLE) and Wi-Fi to provide seamless connectivity for 
                mobile sensors and battery-powered monitoring equipment.
            </span>
        </div>

    </div>
</div>









           </div>
        </div>

        <Padding/>
        <Padding/>

        <Sales/>
        <SEO/>
      </div>
  
      )
    }
  }

export default IOT;

